export enum dbAction {
  "add" = "add",
  "getAll" = "getAll",
  "delete" = "delete",
  "get" = "get",
  "put" = "put",
  "clear" = "clear",
}
export interface DBOpenEvent extends Event {
  target:
    | (EventTarget & { result?: IDBDatabase | undefined })
    | null
    | IDBOpenDBRequest;
}
export interface DBRecord {
  id: string | number;
}
export type StoreName =
  | "NoalGlobalData"
  | "Sites"
  | "Translations"
  | "GeneralData"
  | "Cache"
  | "manageDd";
export interface IndexDBRequest {
  actionType: dbAction;
  storeName: StoreName;
  data: any;
}
export type IndexDBResult<T, E = Error> =
  | { actionRequested?: IndexDBRequest; success: true; data: T; error?: E }
  | { actionRequested?: IndexDBRequest; success: false; data?: T; error: E };

export enum IDBStaus {
  "pending" = "pending",
  "error" = "error",
  "success" = "success",
}
export interface ExtendedErrorOptions {
  message?: string;
  info?: any;
  preMessage?: string;
  postMessage?: string;
}

export class ExtendedError extends Error {
  public info?;
  constructor(orgError: Error, options?: ExtendedErrorOptions) {
    super(orgError.message);
    this.stack = orgError.stack;
    this.name = orgError.name;
    let finalMessage = this.message;
    if (options) {
      if (options.message) {
        finalMessage = options.message;
      }
      if (options.postMessage) {
        finalMessage += options.postMessage;
      }
      if (options.preMessage) {
        finalMessage = options.preMessage + finalMessage;
      }
      if (options.info) {
        this.info = options.info;
      }
    }
    this.message = finalMessage;
    if (finalMessage !== orgError.message) {
      this.stack = orgError.stack
        ? orgError.stack.replace(orgError.message, finalMessage)
        : "";
    }
    Object.setPrototypeOf(this, orgError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_Database/index-db-models.ts